// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2_aUS","modalFooterButton":"ModalNotes_modalFooterButton__NBifw"};